import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
//Hooks
import { useFetch } from '../../hooks/useFetch';
//Components
import { Header } from '../common/Header/Header';
import { BarMenu } from '../common/BarMenu/BarMenu';
import { ModalProduct } from '../Menu/ModalProduct';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import initData from '../Home/initData';
import moment from 'moment';
import { Menu } from '../Menu/Menu';
import { StatusMenu } from '../../api/StatusMenu';
import { AuthFetchAPI } from '../../api/Auth';
import { TablesFetchAPI } from '../../api/Tables';
import { CouponPosFetchAPI } from '../../api/Coupon';
import { ModalCupon } from './ModalCupon';
import { Modal } from 'react-bootstrap';
//Styles

import BannerBrand from '../Banner/BannerBrand';
import Footer from '../Home/Footer';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';


export const Cupons = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState()
    const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const today = days[new Date().getDay()];
    const todayDate = moment().format("YYYY-MM-DD");


    const [showModalCupon, setShowModalCupon] = useState(false);
    const [businessCode, setbusinessCode] = useState(() => {
      if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
         return JSON.parse(localStorage.getItem("business")).code
      }
   });
    const [branchofficeCode, setBranchofficeCode] = useState(() => {
      if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
         return JSON.parse(localStorage.getItem("branchoffice")).code
      }
   });
    const [machineCodeTable, setMachineCodeTable] = useState(() => {
      if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
         return JSON.parse(localStorage.getItem("machine")).code
      }
   });




    //STATES MENU
    const [categories, setCategories] = useState([])
    const [favorites, setFavorites] = useState([])
    const [promotions, setPromotions] = useState([])
    const [groups, setGroups] = useState([])
    const [cupons, setCupons] = useState([])
    const [selectedCupon, setSelectedCupon] = useState({ name: '', description: '', img: '' });

    const [modalShow, setModalShow] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState({});
    const [segmentsGroup, setSegmentsGroup] = useState([])

    const [shoppingcart, setShoppingcart] = useState([])
    const [shoppingCartCombos, setShoppingCartCombos] = useState([])

    const [hy, setHy] = useState([]);

    //----------------------------auth params localstorage---------------------------------------------------
    let machine = "";
    let business = "";
    let branchoffice = "";
    let logo = ""
    let params = false
    let token = undefined
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }
    if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

    } else {
        params = true
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))


        machine = JSON.parse(localStorage.getItem('machine'));
        business = JSON.parse(localStorage.getItem("business"));
    }
    //---------------------------------------------------------------------------------------------------------





    let title_categori = 'Ensalada552'
    let title_categori1 = 'Sopa'

    //----------------------Data general-----------------------\

    //function get day
    const getDayNow = () => {
        const today = new Date(); // Obtiene la fecha actual
        const dayOfWeek = today.getDay(); // Obtiene el día de la semana (0-6)

        // Mapeo de los días de la semana en inglés
        const daysInEnglish = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

        return daysInEnglish[dayOfWeek];
    };

    //function get interval time betwen catalog
    const filterByTimeRange = (array) => {
        const currentTime = moment(); // Obtiene la hora actual según la zona horaria

        return array.filter(({ minHour, maxHour }) => {
            const minTime = moment(minHour, 'HH:mm:ss'); // Convierte minHour a un objeto moment
            const maxTime = moment(maxHour, 'HH:mm:ss'); // Convierte maxHour a un objeto moment

            // Si el rango cruza la medianoche (por ejemplo, 23:30:00 a 02:00:00)
            if (maxTime.isBefore(minTime)) {
                return currentTime.isAfter(minTime) || currentTime.isBefore(maxTime);
            }

            // Si el rango no cruza la medianoche (por ejemplo, 00:00:00 a 03:00:00)
            return currentTime.isBetween(minTime, maxTime, null, '[)');
        });
    };

    //consolidates data into corresponding statements
    const dataconsolidation = (generalData) => {
        if (generalData == 'error') { navigate(`/branch`) }
        let data = generalData


        //section promotions---------------------------------------------------

        //filter promotion by status 1
        let dataPromotions = data.promotions

        let dataTemp = [];
        dataPromotions.forEach((promotionNow) => {
            if (promotionNow.status == 1) {
                dataTemp.push(promotionNow)
            }
        })

        setPromotions(dataTemp)

        //--------------------------------------------------------------------
        //section categories------------------------------------------------
        let dataGroups = data.groups
        let groups_all = dataGroups.filter(({ status }) => status === 1);


        let categories_info = data.category
        //filter status available
        let catalogsavailable = data.catalogs.filter(({ status }) => status === 1);
        let dataday = getDayNow()
        // Filtra los catálogos que tienen el valor del día actual igual a 1
        let filterCatalogsDay = catalogsavailable.filter((catalog) => catalog[dataday] === 1);

        let catalogInTime = filterByTimeRange(filterCatalogsDay)

        if (catalogInTime.length > 0) {

            let catalogToCategories = []
            categories_info.forEach((category) => {
                let filter = catalogInTime[0].categories.find(({ category_id }) => category_id == category.category_id)
                if (filter != undefined) {
                    catalogToCategories.push(category)
                }
            })

            setCategoriesShow(catalogToCategories)
        } else {
            setCategoriesShow(categories_info)
        }

        let categoriesDetails = []
        function setCategoriesShow(categoriesDetails) {
            let dataCategories = categoriesDetails
            let typeCodeCategories = 'P'
            let categoriesFilter = dataCategories.filter(({ code }) => code === typeCodeCategories);
            setCategories(categoriesFilter)

            //safe all groups by categories
            let allgroupsByCategories = []
            categoriesFilter.forEach((categorie) => {
                allgroupsByCategories = allgroupsByCategories.concat(categorie.groups)
            })

            setGroups(allgroupsByCategories)


            //section favorites------------------------------------------------
            let dataFavoriteGroups = allgroupsByCategories.filter(({ favorite }) => favorite == 1)
            setFavorites(dataFavoriteGroups)


            getCouponByBranch()

        }


        //---------------------------------------------------------------------



        //--------------------------DATA SHOPPINGCART-------------------------------------------

        if (localStorage.getItem('shoppingCart') == null || localStorage.getItem('shoppingCart') == undefined || localStorage.getItem('shoppingCart') == "") {
            setShoppingcart([])
        } else {
            let datashopingcart = JSON.parse(localStorage.getItem('shoppingCart'))
            setShoppingcart(datashopingcart)
        }

        if (localStorage.getItem('shoppingCartCombos') == null || localStorage.getItem('shoppingCartCombos') == undefined || localStorage.getItem('shoppingCartCombos') == "") {
            setShoppingCartCombos([])
        } else {
            let datashopingcart = JSON.parse(localStorage.getItem('shoppingCartCombos'))
            setShoppingCartCombos(datashopingcart)
        }

    }


    const getCouponByBranch = async () => {
        try {
            const response = await CouponPosFetchAPI.getCuponsByBranch(token, branchoffice.id)
            setCupons(cuponValidationDataAndCondition(response.data.data))
        } catch (error) {
            //console.log(error);
        }
    }

    const cuponValidationDataAndCondition = (cupons) => {
        const cuponsValidos = cupons.filter(cupon => {
            const diasValidos = cupon.conditions
                .filter(cond => cond.type === "DAY")
                .map(cond => cond.value);

            if (diasValidos.length === 0) return false;
            if (cupon.visible_ecommerce == 0) return false

            const esDiaValido = diasValidos.includes(today);

            const expiracion = cupon.conditions.find(cond => cond.type === "expiration_date");
            const noExpirado = !expiracion || moment(expiracion.value).isSameOrAfter(todayDate, "day");

            // --- Soporte para múltiples objetos TIME ---
            let timeConds = cupon.conditions
                .filter(cond => cond.type === "TIME")
                .map(cond => cond.value);

            let enRangoHora = true;

            if (timeConds.length > 0) {
                // Si solo hay un valor y contiene un guion, es un rango explícito
                if (timeConds.length === 1 && timeConds[0].includes('-')) {
                    let [start, end] = timeConds[0].split('-').map(s => s.trim());
                    if (start.length === 5) start += ':00';
                    if (end.length === 5) end += ':00';
                    const now = moment();
                    const startTime = moment(start, "HH:mm:ss");
                    const endTime = moment(end, "HH:mm:ss");
                    if (!startTime.isValid() || !endTime.isValid()) {
                        enRangoHora = false;
                    } else if (endTime.isBefore(startTime)) {
                        enRangoHora = now.isAfter(startTime) || now.isBefore(endTime);
                    } else {
                        enRangoHora = now.isBetween(startTime, endTime, undefined, '[)');
                    }
                } else {
                    // Si hay varios TIME, o uno solo sin guion, toma el menor y mayor como rango
                    let valores = timeConds.map(v => v.length === 5 ? v + ':00' : v);
                    valores = valores.filter(Boolean).sort();
                    let start, end;

                    //valida que los valores tengan el formato correcto de acuerdo al tamaño del arreglo de valores
                    if (valores.length === 1) {
                        start = "00:00:00";
                        end = valores[0];
                    } else {
                        start = valores[0];
                        end = valores[valores.length - 1];
                    }

                    const now = moment();
                    const startTime = moment(start, "HH:mm:ss");
                    const endTime = moment(end, "HH:mm:ss");
                    if (!startTime.isValid() || !endTime.isValid()) {
                        enRangoHora = false;
                    } else if (endTime.isBefore(startTime)) {
                        enRangoHora = now.isAfter(startTime) || now.isBefore(endTime);
                    } else if (start === end) {
                        enRangoHora = now.format("HH:mm:ss") === startTime.format("HH:mm:ss");
                    } else {
                        enRangoHora = now.isBetween(startTime, endTime, undefined, '[)');
                    }
                }
            }
            return esDiaValido && noExpirado && enRangoHora;
        });

        return cuponsValidos;
    }

    const getCupons = async (cupon_id) => {
        try {
            const response = await CouponPosFetchAPI.getCupon(cupon_id, token)
            setSelectedCupon(response.data.data)
            setShowModalCupon(true)
        } catch (error) {
        }
    }

    const handlerInit = async () => {
        try {
            let response = await initData()
            dataconsolidation(response)
        } catch (err) {
            navigate(`/branch/${businessCode}`)
        }
    }



    useEffect(() => {

        handlerInit()
    }, [])




    return (
        <>

            <main className=''>
                <div className='bg-white category-item-enter'>
                    <Header nameBussines={business.name} shoppingcart={shoppingcart} shoppingCartCombos={shoppingCartCombos}></Header>
                </div>
                <div className='border border-1 border-light-subtle bg-light mb-4'>
                    <div className='container py-lg-5 py-2'>
                        <h2 className='text-secondary text-center'>Cupones y Ofertas</h2>
                    </div>
                </div>

                <div className='container '>
                    <div className='d-flex justify-content-between align-items-center'>
                        <NavLink to={`/home`}  >
                            <button className='btn btn-outline-secondary rounded-pill   p-0 border-0'>
                                <span className='d-flex align-items-center fw-bold px-3 py-1'> <i class="uil uil-arrow-left icon-header-ecommerce"></i>  Inicio </span>
                            </button>
                        </NavLink>


                    </div>

                    <span className='subtitle-ecommerce'>
                        Cupones
                    </span>
                    <div className="row container-card-favorite mx-1 g-2">

                        {cupons.map((data) => (
                            <div className='col-6 col-md-3 mt-2'>
                                <div className="card-categories border border-1 rounded-3  p-1 h-100" onClick={() => getCupons(data.cupon_id)}>
                                    <div className="d-flex justify-content-start position-relative">
                                        <img src={buildCloudinaryImageUrl({ url: data.img != null ? data.img : logo, width: 300, quality: "auto", type: "image" }) || undefined}
                                            alt="Product" className=" img-favorite-menu  rounded-3" />

                                    </div>
                                    <span className="card-recomend-title" >
                                        {data.name}
                                    </span>
                                    <span className="card-recomend-description" >
                                        {data.description}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <Footer></Footer>
            </main>
            <ModalCupon showModalCupon={showModalCupon} setShowModalCupon={setShowModalCupon} selectedCupon={selectedCupon} token={token}></ModalCupon>
        </>
    )
}
